import { useState } from 'react';

const STORAGE_KEY = 'kynward_presence_anon_id';

function randomId(): string {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return `a_${crypto.randomUUID().replace(/-/g, '').slice(0, 12)}`;
  }
  return `a_${Math.random().toString(36).slice(2, 14)}`;
}

export function readOrCreateAnonId(): string {
  if (typeof window === 'undefined' || !window.localStorage) return randomId();
  try {
    const v = localStorage.getItem(STORAGE_KEY)?.trim();
    if (v) return v;
    const n = randomId();
    localStorage.setItem(STORAGE_KEY, n);
    return n;
  } catch {
    return randomId();
  }
}

/**
 * Stable anonymous id for feature assignment + API correlation.
 */
export function useAnonId(): string {
  return useState(() => readOrCreateAnonId())[0];
}

export function setAnonIdForTests(id: string) {
  try {
    localStorage.setItem(STORAGE_KEY, id);
  } catch {
    /* dev/test */
  }
}
